/**
 * 登入驗證錯誤公版，
 * propData 等於上一層的props
 */
export const ToAuthorizationErrorPage = (propData) => {
  // 因 eservice 頁面天地會用 channelId 判斷是否顯示
  // 在導頁的時候須把 channelId 一並帶入
  propData.history.push(
    {
      pathname: '/resultController/ResultPage',
      search: '?channelId=' + window.channelId,
    },
    {
      type: 'fail',
      pageName: '',
      title: '',
      description: '您登入的門號/帳號不適用此服務，謝謝!',
      actions: [
        {
          text: '前往個人專區',
          link: process.env.REACT_APP_HOME_PAGE + window.channelId,
          btnStyle: 'primary',
        },
      ],
    }
  );
};

/**
 * 業務 API 錯誤通用導頁公版
 * @param {Object} propData 或 history 物件
 * @param {string} description 說明文字
 * @param {string} title 標題
 * @param {string} pageName 頁面名稱
 */
export const ToResultErrorPage = (
  propData,
  description = '很抱歉！目前系統忙碌中，請稍後再試。',
  title = '系統繁忙中',
  pageName = '5G+ 優先通行'
) => {
  const history = propData && (propData.history || propData);
  if (!history || typeof history.push !== 'function') return;
  const channelId = typeof window !== 'undefined' ? window.channelId || '' : '';
  history.push(
    {
      pathname: '/resultController/ResultPage',
      search: '?channelId=' + channelId,
    },
    {
      type: 'fail',
      pageName,
      title,
      description,
      actions: [
        {
          text: '返回 5G+ 首頁',
          link: '/5gsaController/5gsa?channelId=' + channelId,
          btnStyle: 'primary',
        },
      ],
    }
  );
};

